import type { AppState, AppStateAction } from '@/providers/app-provider/types';
import type { StepValues } from '@repo/common';
import type { ComponentType, Dispatch } from 'react';

import { useAppContext } from '@/providers/app-provider/context';
import { selectStep } from '@/providers/app-provider/selectors';

function canRenderByOptionOnly(optionOnly: WithStepOptions['only'], step: StepValues): boolean {
  return !!optionOnly && optionOnly.includes(step);
}

export type WithStepOptions = {
  only?: StepValues[];
};

type WithStepProps = {
  alternateStep: AppState['alternateStep'];
  dispatch: Dispatch<AppStateAction>;
  step: NonNullable<AppState['steps'][0]>;
  workflow: NonNullable<AppState['workflow']>;
};

export const withStep =
  (options: WithStepOptions = {}) =>
  <P extends object>(Component: ComponentType<P & WithStepProps>): React.FC<P> =>
  (props) => {
    const { dispatch, state } = useAppContext();
    const { alternateStep, workflow } = state;
    const step = selectStep(state);

    if (!workflow || !step) {
      return null;
    }

    if (!canRenderByOptionOnly(options.only, step.value)) {
      return null;
    }

    return <Component {...props} alternateStep={alternateStep} dispatch={dispatch} step={step} workflow={workflow} />;
  };
